import React from "react"

export function Restore(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M0.888672 5.25105H0.65625C0.292578 5.25105 0 4.95847 0 4.5948V1.0948C0 0.829566 0.158594 0.588941 0.404687 0.487769C0.650781 0.386597 0.932422 0.441285 1.12109 0.629957L2.25859 1.76746C4.65391 -0.597778 8.51211 -0.589575 10.8938 1.7948C13.2863 4.18738 13.2863 8.06472 10.8938 10.4573C8.50117 12.8499 4.62383 12.8499 2.23125 10.4573C1.88945 10.1155 1.88945 9.56043 2.23125 9.21863C2.57305 8.87683 3.12812 8.87683 3.46992 9.21863C5.17891 10.9276 7.94883 10.9276 9.65781 9.21863C11.3668 7.50964 11.3668 4.73972 9.65781 3.03074C7.95703 1.32996 5.20898 1.32175 3.49727 3.00339L4.62109 4.12996C4.80977 4.31863 4.86445 4.60027 4.76328 4.84636C4.66211 5.09246 4.42148 5.25105 4.15625 5.25105H0.888672Z"
        fill="#4CAF50"
      />
    </svg>
  )
}
